const getCameFromRouteName = state => state.cameFromRouteName;

export default {
  getCameFromRouteName
};



// WEBPACK FOOTER //
// ./src/store/modules/exercises/getters.js